import { Button } from '@/components/ui/button';
import { getErrorMessage } from '@/lib/errors';
import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * One sentence about what failed and one way out of it. Text-first on purpose:
 * a full-panel illustration to say "something broke" tells the reader nothing
 * the sentence does not already say.
 */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-6 py-8 text-center">
      <TriangleAlert aria-hidden className="size-5 text-danger" />
      <div className="text-md font-medium text-foreground">{t('common.error')}</div>
      <p className="max-w-[420px] text-sm text-muted-foreground">{t(getErrorMessage(error))}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
